import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'allLots',
    'lotSelection'
  ]

  connect () {
    this.toggle()
  }

  // La sélection manuelle n'a pas de sens quand tous les lots sont diffusés
  toggle () {
    this.lotSelectionTarget.hidden = this.allLotsTarget.checked
  }
}
